var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93046 20.6044H0.363762V6.8482H4.93046V20.6044ZM2.64465 4.97173C1.18469 4.97173 0 3.84033 0 2.47437C0 1.10841 1.18469 0 2.64465 0C4.10462 0 5.2893 1.10841 5.2893 2.47437C5.2893 3.84033 4.10462 4.97173 2.64465 4.97173ZM22.0224 20.6044H17.4655V13.908C17.4655 12.312 17.4311 10.2654 15.0912 10.2654C12.7169 10.2654 12.3532 11.9993 12.3532 13.793V20.6044H7.7914V6.8482H12.1713V8.72467H12.2352C12.8447 7.64386 14.3342 6.50326 16.5561 6.50326C21.1769 6.50326 22.0273 9.35016 22.0273 13.0479V20.6044H22.0224Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.5079e9bfd786de7d3a692e8752f97b10.svg";
export { ForwardRef as ReactComponent };